import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * White floating card for an insight chart: title, subtitle and an optional filter.
 * Put the filter in `[insightCardAction]` and the chart as the content. Size it from the
 * parent grid by classes on the host, e.g. `class="col-span-12 md:col-span-6"`.
 */
@Component({
  selector: 'lib-insight-card',
  templateUrl: './insight-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    // floating-card-fit: keeps the floating layout's stretch-last-card rule off a grid of cards
    class: 'floating-card floating-card-fit p-xl flex flex-col gap-lg min-w-0',
  },
})
export class InsightCardComponent {
  readonly cardTitle = input.required<string>();
  readonly subtitle = input<string>('');
}
